var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRPoorSignal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10825_72359)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 12.5C8.39782 12.5 8.77936 12.658 9.06066 12.9393C9.34196 13.2206 9.5 13.6022 9.5 14V19C9.5 19.3978 9.34196 19.7794 9.06066 20.0607C8.77936 20.342 8.39782 20.5 8 20.5C7.60218 20.5 7.22064 20.342 6.93934 20.0607C6.65804 19.7794 6.5 19.3978 6.5 19V14C6.5 13.6022 6.65804 13.2206 6.93934 12.9393C7.22064 12.658 7.60218 12.5 8 12.5Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 15.5C4.39782 15.5 4.77936 15.658 5.06066 15.9393C5.34196 16.2206 5.5 16.6022 5.5 17V19C5.5 19.3978 5.34196 19.7794 5.06066 20.0607C4.77936 20.342 4.39782 20.5 4 20.5C3.60218 20.5 3.22064 20.342 2.93934 20.0607C2.65804 19.7794 2.5 19.3978 2.5 19V17C2.5 16.6022 2.65804 16.2206 2.93934 15.9393C3.22064 15.658 3.60218 15.5 4 15.5Z",
    fill: "#C7432B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 9.5C12.3978 9.5 12.7794 9.65804 13.0607 9.93934C13.342 10.2206 13.5 10.6022 13.5 11V19C13.5 19.3978 13.342 19.7794 13.0607 20.0607C12.7794 20.342 12.3978 20.5 12 20.5C11.6022 20.5 11.2206 20.342 10.9393 20.0607C10.658 19.7794 10.5 19.3978 10.5 19V11C10.5 10.6022 10.658 10.2206 10.9393 9.93934C11.2206 9.65804 11.6022 9.5 12 9.5Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 6.5C16.3978 6.5 16.7794 6.65804 17.0607 6.93934C17.342 7.22064 17.5 7.60218 17.5 8V19C17.5 19.3978 17.342 19.7794 17.0607 20.0607C16.7794 20.342 16.3978 20.5 16 20.5C15.6022 20.5 15.2206 20.342 14.9393 20.0607C14.658 19.7794 14.5 19.3978 14.5 19V8C14.5 7.60218 14.658 7.22064 14.9393 6.93934C15.2206 6.65804 15.6022 6.5 16 6.5Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.99412 9.5V1.58081H4.66994C5.28863 1.58081 5.79647 1.6865 6.19346 1.89788C6.59045 2.10669 6.88433 2.39412 7.07509 2.76018C7.26585 3.12624 7.36123 3.54256 7.36123 4.00915C7.36123 4.47575 7.26585 4.88949 7.07509 5.25039C6.88433 5.61129 6.59174 5.89486 6.19733 6.10109C5.80291 6.30474 5.29894 6.40657 4.68541 6.40657H2.52V5.5404H4.65447C5.07724 5.5404 5.41752 5.47854 5.67531 5.3548C5.93567 5.23106 6.12386 5.05577 6.23986 4.82891C6.35844 4.59948 6.41773 4.32623 6.41773 4.00915C6.41773 3.69208 6.35844 3.41496 6.23986 3.17779C6.12128 2.94063 5.93181 2.7576 5.67144 2.62871C5.41108 2.49724 5.06693 2.4315 4.63901 2.4315H2.95309V9.5H1.99412ZM5.72171 5.94255L7.67057 9.5H6.55694L4.63901 5.94255H5.72171Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10825_72359"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRPoorSignal);
export default __webpack_public_path__ + "static/media/r_poor_signal.e349a2375d973e8ff1f36bcd3e1271c7.svg";
export { ForwardRef as ReactComponent };